export default {
  data: [
    // 这些是速拼的数据
    {
      name: "基础信息",
      key: "/dashboard/baseInfo",
      icon: "user",
      power: 0,
      sub: [
        {
          name: "区域配置",
          key: "/dashboard/baseInfo/config",
          icon: "user",
          power: 0,
        },
      ],
    },
    {
      name: "模块管理",
      key: "/dashboard/moduleManage",
      icon: "user",
      power: 0,
      sub: [
        {
          name: "模块列表",
          key: "/dashboard/moduleManage/module",
          icon: "user",
          power: 0,
        },
      ],
    },
    {
      name: "分类管理",
      key: "/dashboard/categoryManage",
      icon: "user",
      power: 0,
      sub: [
        {
          name: "分类列表",
          key: "/dashboard/categoryManage/category",
          icon: "user",
          power: 0,
        },
      ],
    },
    {
      name: "商品管理",
      key: "/dashboard/goodsManage",
      icon: "user",
      power: 0,
      sub: [
        {
          name: "商品列表",
          key: "/dashboard/goodsManage/goods",
          icon: "user",
          power: 0,
        },
      ],
    },
    {
      name: "文章管理",
      key: "/dashboard/articleManage",
      icon: "user",
      power: 0,
      sub: [
        {
          name: "文章列表",
          key: "/dashboard/articleManage/article",
          icon: "user",
          power: 0,
        },
      ],
    },
    {
      name: "品牌管理",
      key: "/dashboard/brandManage",
      icon: "user",
      power: 0,
      sub: [
        {
          name: "品牌列表",
          key: "/dashboard/brandManage/brand",
          icon: "user",
          power: 0,
        },
      ],
    },
   /*  {
      name: "材质管理",
      key: "/dashboard/Material",
      icon: "user",
      power: 0,
      sub: [
        {
          name: "材质列表",
          key: "/dashboard/Material/index",
          icon: "user",
          power: 0,
        },
      ],
    }, */
    {
      name: "Banner管理",
      key: "/dashboard/bannerManage",
      icon: "user",
      power: 0,
      sub: [
        {
          name: "Banner列表",
          key: "/dashboard/bannerManage/banner",
          icon: "user",
          power: 0,
        },
      ],
    },
    {
      name: "预约列表",
      key: "/dashboard/reservation",
      icon: "user",
      power: 0,
      sub: [
        {
          name: "预约列表",
          key: "/dashboard/reservation/index",
          icon: "user",
          power: 0,
        },
      ],
    },
    {
      name: "交易管理",
      key: "/dashboard/tradeManage",
      icon: "user",
      power: 0,
      sub: [
        {
          name: "交易设置",
          key: "/dashboard/tradeManage/config",
          icon: "user",
          power: 0,
        },
        {
          name: "客户管理",
          key: "/dashboard/tradeManage/mpUser",
          icon: "user",
          power: 0,
        },
        {
          name: "订单管理",
          key: "/dashboard/tradeManage/order",
          icon: "user",
          power: 0,
        },
        {
          name: "售后管理",
          key: "/dashboard/tradeManage/refund",
          icon: "user",
          power: 0,
        },
        {
          name: "评论管理",
          key: "/dashboard/tradeManage/comment",
          icon: "user",
          power: 0,
        },
      ],
    },
    /* {
      name: "翻译管理",
      key: "/dashboard/translateManage",
      icon: "user",
      power: 0,
      sub: [
        {
          name: "翻译列表",
          key: "/dashboard/translateManage/translate",
          icon: "user",
          power: 0,
        },
      ],
    }, */

    // 以下是旧项目数据,可以删除
    {
      name: "用户管理",
      key: "/dashboard/user",
      icon: "user",
      power: 2,
      sub: [
        { name: "用户列表", key: "/dashboard/user/wx", icon: "user", power: 2 },
        {
          name: "黑词命中用户",
          key: "/dashboard/user/wordsuser",
          icon: "inbox",
          power: 2,
        },
        {
          name: "黑词列表",
          key: "/dashboard/user/wordslist",
          icon: "inbox",
          power: 2,
        },
        {
          name: "文字命中排行",
          key: "/dashboard/user/words",
          icon: "inbox",
          power: 2,
        },
        {
          name: "查看个人数据",
          key: "/dashboard/user/userextend",
          icon: "inbox",
          power: 8,
        },
        {
          name: "登录记录",
          key: "/dashboard/user/loglist",
          icon: "inbox",
          power: 32,
        },
        {
          name: "facebook迁移",
          key: "/dashboard/user/facebookuser",
          icon: "inbox",
          power: 16384,
        },
        {
          name: "封禁记录",
          key: "/dashboard/user/forbid",
          icon: "inbox",
          power: 8192,
        },
        {
          name: "召集功能黑名单",
          key: "/dashboard/user/gather",
          icon: "inbox",
          power: 2048,
        },
        {
          name: "ip mac关联信息",
          key: "/dashboard/user/InfoByIpOrMac",
          icon: "inbox",
          power: 8192,
        },
      ],
    },
    {
      name: "外管团队",
      key: "/dashboard/outerteam",
      icon: "inbox",
      power: 2097152,
      sub: [
        {
          name: "团队列表",
          key: "/dashboard/outerteam/outerTeamList",
          icon: "inbox",
          power: 2097152,
        },
        // { name: '外管团队成员', key: '/dashboard/outerteam/outerTeamMemberList', icon: 'inbox', power: 2097152 },
        {
          name: "外管团队工资发放记录",
          key: "/dashboard/outerteam/outerTeamCoinGivenHistoryList",
          icon: "inbox",
          power: 2097152,
        },
      ],
    },
    {
      name: "翻译",
      key: "/dashboard/translate",
      icon: "inbox",
      power: 2,
      sub: [
        {
          name: "翻译任务列表",
          key: "/dashboard/translate/list",
          icon: "inbox",
          power: 2,
        },
        {
          name: "翻译文字",
          key: "/dashboard/translate/item",
          icon: "inbox",
          power: 2,
        },
      ],
    },
    {
      name: "房间",
      key: "/dashboard/group",
      icon: "inbox",
      power: 64,
      sub: [
        {
          name: "房间列表",
          key: "/dashboard/group/list",
          icon: "inbox",
          power: 64,
        },
        {
          name: "房间金币总额",
          key: "/dashboard/group/roomgiftrecordlist",
          icon: "inbox",
          power: 524288,
        },
        {
          name: "记录明细",
          key: "/dashboard/group/giftrecordlist",
          icon: "inbox",
          power: 1048576,
        },
        {
          name: "房间每日数据",
          key: "/dashboard/group/roomdetail",
          icon: "inbox",
          power: 524288,
        },
        {
          name: "主题房间配置",
          key: "/dashboard/group/room",
          icon: "inbox",
          power: 8388608,
        },
      ],
    },
    {
      name: "Banner",
      key: "/dashboard/banner",
      icon: "inbox",
      power: 4194304,
      sub: [
        {
          name: "首页Banner",
          key: "/dashboard/banner/banner",
          icon: "inbox",
          power: 4194304,
        },
        {
          name: "房间Banner",
          key: "/dashboard/banner/bannerroom",
          icon: "inbox",
          power: 4194304,
        },
        {
          name: "启动弹窗",
          key: "/dashboard/banner/popups",
          icon: "inbox",
          power: 4194304,
        },
        // { name: '启动闪屏', key: '/dashboard/banner/splash', icon: 'inbox', power: 4194304 },
      ],
    },
    {
      name: "礼物",
      key: "/dashboard/gift",
      icon: "inbox",
      power: 512,
      sub: [
        {
          name: "礼物列表",
          key: "/dashboard/gift/list",
          icon: "inbox",
          power: 67108864,
        },
        {
          name: "礼物赠送",
          key: "/dashboard/gift/send",
          icon: "inbox",
          power: 67108864,
        },
        {
          name: "礼物数据",
          key: "/dashboard/gift/statgift",
          icon: "inbox",
          power: 512,
        },
      ],
    },
    {
      name: "坐骑",
      key: "/dashboard/horse",
      icon: "inbox",
      power: 2048,
      sub: [
        {
          name: "坐骑列表",
          key: "/dashboard/horse/list",
          icon: "inbox",
          power: 33554432,
        },
        {
          name: "赠送坐骑",
          key: "/dashboard/horse/give",
          icon: "inbox",
          power: 262144,
        },
        {
          name: "坐骑购买",
          key: "/dashboard/horse/buy",
          icon: "inbox",
          power: 2048,
        },
        {
          name: "坐骑统计",
          key: "/dashboard/horse/horsestat",
          icon: "inbox",
          power: 2048,
        },
      ],
    },
    {
      name: "头饰",
      key: "/dashboard/head",
      icon: "inbox",
      power: 2048,
      sub: [
        {
          name: "头饰列表",
          key: "/dashboard/head/list",
          icon: "inbox",
          power: 33554432,
        },
        {
          name: "赠送头饰",
          key: "/dashboard/head/give",
          icon: "inbox",
          power: 262144,
        },
        {
          name: "头饰购买",
          key: "/dashboard/head/buy",
          icon: "inbox",
          power: 2048,
        },
        {
          name: "购买统计",
          key: "/dashboard/head/headstat",
          icon: "inbox",
          power: 2048,
        },
      ],
    },
    {
      name: "勋章",
      key: "/dashboard/medal",
      icon: "inbox",
      power: 128,
      sub: [
        {
          name: "勋章列表",
          key: "/dashboard/medal/list",
          icon: "inbox",
          power: 16777216,
        },
        {
          name: "勋章墙",
          key: "/dashboard/medal/celllist",
          icon: "inbox",
          power: 16777216,
        },
        {
          name: "勋章撤回",
          key: "/dashboard/medal/del",
          icon: "inbox",
          power: 128,
        },
      ],
    },
    {
      name: "背景",
      key: "/dashboard/background",
      icon: "inbox",
      power: 4096,
      sub: [
        {
          name: "房间背景审核",
          key: "/dashboard/background/backgroundcheck",
          icon: "inbox",
          power: 4096,
        },
        {
          name: "背景列表",
          key: "/dashboard/background/background",
          icon: "inbox",
          power: 8388608,
        },
      ],
    },
    {
      name: "靓号",
      key: "/dashboard/duid",
      icon: "inbox",
      power: 2097152,
      sub: [
        {
          name: "用户靓号买卖",
          key: "/dashboard/duid/duid",
          icon: "inbox",
          power: 2097152,
        },
        {
          name: "用户靓号设置",
          key: "/dashboard/duid/duidlist",
          icon: "inbox",
          power: 2097152,
        },
        {
          name: "用户靓号申请",
          key: "/dashboard/duid/requestduid",
          icon: "inbox",
          power: 2097152,
        },
        {
          name: "房间靓号设置",
          key: "/dashboard/duid/dgidlist",
          icon: "inbox",
          power: 2097152,
        },
      ],
    },
    {
      name: "建议与反馈",
      key: "/dashboard/suggest",
      icon: "inbox",
      power: 16,
      sub: [
        {
          name: "用户举报",
          key: "/dashboard/suggest/report",
          icon: "inbox",
          power: 16,
        },
        {
          name: "用户建议",
          key: "/dashboard/suggest/suggest",
          icon: "inbox",
          power: 16,
        },
      ],
    },
    {
      name: "贵族卡",
      key: "/dashboard/nobility",
      icon: "inbox",
      power: 67108864,
      sub: [
        {
          name: "贵族卡列表",
          key: "/dashboard/nobility/list",
          icon: "inbox",
          power: 67108864,
        },
      ],
    },
    {
      name: "消息",
      key: "/dashboard/msg",
      icon: "inbox",
      power: 8192,
      sub: [
        {
          name: "系统通知",
          key: "/dashboard/msg/notice",
          icon: "inbox",
          power: 32768,
        },
        {
          name: "官方公告",
          key: "/dashboard/msg/activity",
          icon: "inbox",
          power: 32768,
        },
        {
          name: "消息推送",
          key: "/dashboard/msg/push",
          icon: "inbox",
          power: 4194304,
        },
        {
          name: "用户反馈",
          key: "/dashboard/msg/list",
          icon: "inbox",
          power: 2097152,
          uids: "10000,105716,105490,100936,119040,633008,651745,392068,101841",
        },
        {
          name: "FAQ",
          key: "/dashboard/msg/faq",
          icon: "inbox",
          power: 2097152,
          uids: "10000,105716,105490,100936,119040,633008,651745,392068,101841",
        },
        // { name: '客服', key: '/dashboard/msg/chat', icon: 'inbox', power: 8192, blank: true },
      ],
    },
    {
      name: "货币",
      key: "/dashboard/gold",
      icon: "inbox",
      power: 256,
      sub: [
        {
          name: "金币钻石",
          key: "/dashboard/gold/userextend",
          icon: "inbox",
          power: 128,
        },
        {
          name: "订单",
          key: "/dashboard/gold/order",
          icon: "inbox",
          power: 256,
        },
        {
          name: "用户充值查询",
          key: "/dashboard/gold/userorder",
          icon: "inbox",
          power: 256,
        },
        {
          name: "ios充值校对",
          key: "/dashboard/gold/iospay",
          icon: "inbox",
          power: 256,
        },
        {
          name: "货币明细",
          key: "/dashboard/gold/golddetail",
          icon: "inbox",
          power: 536870912,
        },
      ],
    },
    {
      name: "每日数据",
      key: "/dashboard/stat",
      icon: "inbox",
      power: 65536,
      sub: [
        {
          name: "数据概况(隔日更新)",
          key: "/dashboard/stat/index",
          icon: "inbox",
          power: 536870912,
        },
        {
          name: "国家数据概况(隔日更新)",
          key: "/dashboard/stat/country",
          icon: "inbox",
          power: 536870912,
        },
        {
          name: "月度核心数据报表",
          key: "/dashboard/stat/coreReporting",
          icon: "inbox",
          power: 536870912,
        },
        {
          name: "重点用户跟踪报表",
          key: "/dashboard/stat/importantUserMonitorList",
          icon: "inbox",
          power: 524288,
        },
        {
          name: "实时数据",
          key: "/dashboard/stat/realtime",
          icon: "inbox",
          power: 536870912,
        },
        {
          name: "房间活跃人数",
          key: "/dashboard/stat/roomuser",
          icon: "inbox",
          power: 65536,
        },
        {
          name: "房间数据概况",
          key: "/dashboard/stat/room",
          icon: "inbox",
          power: 65536,
        },
        {
          name: "在线国家",
          key: "/dashboard/stat/statcountryonlive",
          icon: "inbox",
          power: 131072,
        },
        {
          name: "猜拳数据",
          key: "/dashboard/stat/guess",
          icon: "inbox",
          power: 1024,
        },
        {
          name: "运营核心指标概况表",
          key: "/dashboard/stat/kpiOverview",
          icon: "inbox",
          power: 268435456,
        },
        {
          name: "运营核心指标明细表",
          key: "/dashboard/stat/kpiDetails",
          icon: "inbox",
          power: 268435456,
        },
        // { name: '房间列表', key: '/dashboard/stat/admingroup', icon: 'inbox', power: 536870912 },
        // { name: '房间筛选', key: '/dashboard/stat/groupSummary', icon: 'inbox', power: 536870912 },
      ],
    },
    {
      name: "APP配置",
      key: "/dashboard/app",
      icon: "inbox",
      power: 536870912,
      sub: [
        {
          name: "配置列表",
          key: "/dashboard/app/set",
          icon: "inbox",
          power: 536870912,
        },
      ],
    },
    {
      name: "活动管理",
      key: "/dashboard/activity",
      icon: "inbox",
      power: 4096,
      sub: [
        {
          name: "单页",
          key: "/dashboard/activity/actpages",
          icon: "inbox",
          power: 32768,
        },
        {
          name: "玫瑰女王",
          key: "/dashboard/activity/rose",
          icon: "inbox",
          power: 32768,
        },
        {
          name: "锦标赛",
          key: "/dashboard/activity/gametournament",
          icon: "inbox",
          power: 32768,
        },
        {
          name: "房间活动管理",
          key: "/dashboard/activity/actmg",
          icon: "inbox",
          power: 4096,
        },
        {
          name: "投票国家",
          key: "/dashboard/activity/countrylist",
          icon: "inbox",
          power: 32768,
        },
        {
          name: "投票人",
          key: "/dashboard/activity/user",
          icon: "inbox",
          power: 32768,
        },
        {
          name: "房间扶持-报名房间",
          key: "/dashboard/activity/roomsupport",
          icon: "inbox",
          power: 32768,
        },
        {
          name: "房间扶持-奖励记录",
          key: "/dashboard/activity/GroupSupperRecord",
          icon: "inbox",
          power: 32768,
        },
        {
          name: "金蛋概率",
          key: "/dashboard/activity/changedan",
          icon: "inbox",
          power: 134217728,
        },
        {
          name: "金蛋中奖记录",
          key: "/dashboard/activity/changedanRecord",
          icon: "inbox",
          power: 134217728,
        },
      ],
    },
    {
      name: "灯笼x福袋x礼包",
      key: "/dashboard/light",
      icon: "inbox",
      power: 134217728,
      sub: [
        {
          name: "被抽奖的物品",
          key: "/dashboard/light/prize",
          icon: "inbox",
          power: 536870912,
        },
        {
          name: "情人节抽奖概率",
          key: "/dashboard/light/chancetree",
          icon: "inbox",
          power: 134217728,
        },
        {
          name: "充值抽奖概率",
          key: "/dashboard/light/changelv",
          icon: "inbox",
          power: 134217728,
        },
        {
          name: "灯笼",
          key: "/dashboard/light/list",
          icon: "inbox",
          power: 134217728,
        },
        {
          name: "送福袋礼物得灯笼概率",
          key: "/dashboard/light/change",
          icon: "inbox",
          power: 134217728,
        },
        {
          name: "签到得灯笼概率",
          key: "/dashboard/light/changeSign",
          icon: "inbox",
          power: 134217728,
        },
        {
          name: "礼包",
          key: "/dashboard/light/pack",
          icon: "inbox",
          power: 134217728,
        },
        {
          name: "用灯笼兑换礼包",
          key: "/dashboard/light/lightpack",
          icon: "inbox",
          power: 134217728,
        },
        {
          name: "福袋灯笼礼包数据",
          key: "/dashboard/light/stat",
          icon: "inbox",
          power: 134217728,
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./core/menu.js